export default __webpack_public_path__ + "static/media/be-sure-stepsliide5.48003ed7.png";